import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export const ProtectedRoute = ({ children, roles }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) return (
        <div className="min-h-screen w-full flex items-center justify-center">
            <Loader2 className="animate-spin text-[#FF5A00]" size={22} />
        </div>
    );
    if (!user) {
        const next = encodeURIComponent(location.pathname + location.search);
        return <Navigate to={`/login?next=${next}`} replace />;
    }
    const wantsStaff = roles?.some((r) => r === "admin" || r === "staff");
    if (roles?.length && (wantsStaff ? user.role === "client" : !roles.includes(user.role))) {
        return <Navigate to={user.role !== "client" ? "/dashboard" : "/account"} replace />;
    }
    return children;
};
